import styled from '@emotion/styled'

import sanitizeHtml from 'sanitize-html'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import type { PageConfig } from '@segment/contexts/page'
import { usePageConfig } from '@segment/contexts/page'

const getCopy = (pageConfig: PageConfig) => ({
  heading: `Segment is a powerful complement to your data warehouse`,
  description: [
    {
      paragraph: `With <a href="${getAbsoluteUrl(
        `/product/reverse-etl/`,
        pageConfig
      )}">Reverse ETL</a> and <a href="${getAbsoluteUrl(
        `/product/unify/`,
        pageConfig
      )}">Unify</a>, Segment customers can choose to make their warehouse a source of truth while leveraging Segment to deliver accurate, rich customer profiles that can be activated in hundreds of downstream channels. Reverse ETL helps companies activate data in the warehouse by sending it directly to downstream destinations like a company’s marketing or analytics tools of choice.`,
    },
    {
      paragraph: `What’s more, Forrester cited a <a href="https://learn.segment.com/forrester-tei-report/">35% reduction in data engineers’ time spent on data management</a> activities when using Segment, compared to home-grown solutions, representing a significant cost savings and offering a boost to the happiness of engineers everywhere.`,
    },
  ],
})

const PowerfulCompliment = () => {
  const pageConfig = usePageConfig()
  const copy = getCopy(pageConfig)
  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <StyledCopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          {copy.description.map((text, index) => (
            <CopyText.Description
              key={index}
              tag="p"
              variant="pLarge"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(text.paragraph, { allowedTags: [`a`] }),
              }}
            />
          ))}
        </StyledCopyTextBase>
      </Section.Copy>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-bottom: 0;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-bottom: 40px;
    }
  }
`

const StyledCopyTextBase = styled(CopyTextBase)`
  text-align: start;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    text-align: center;
  }
`

export default PowerfulCompliment
